import { PiRocketLaunch, PiUsers } from 'react-icons/pi'
import { Link } from 'react-router-dom'

import MotionDiv from '@/components/common/Motion/MotionDiv'
import MotionText from '@/components/common/Motion/MotionText'

type AwarenessStage = 'unaware' | 'problem' | 'solution' | 'product'

interface FinhudasCTAProps {
  variant?: 'default' | 'compact'
  awareness?: AwarenessStage
}

const ctaCopy: Record<AwarenessStage, { heading: string; body: string; button: string }> = {
  unaware: {
    heading: 'Ar žinote, kiek mokesčių\niš tikrųjų mokate?',
    body: 'Dauguma pavežėjų permoka šimtus eurų per metus. Sužinokite savo tikrą mokesčių sumą per 3 minutes.',
    button: 'Pasitikrinti nemokamai',
  },
  problem: {
    heading: 'Pavargote nuo mokesčių\nchaoso?',
    body: 'GPM, VSD, PSD, atvirkštinis PVM — Finhudas viską suskaičiuoja automatiškai iš jūsų Bolt ataskaitų.',
    button: 'Išbandyti nemokamai',
  },
  solution: {
    heading: 'Automatinė apskaita —\nne rankinis copy-paste',
    body: 'Importuokite Bolt ataskaitas vienu paspaudimu. Mokesčiai, žurnalas ir deklaracijos — per 3 minutes.',
    button: 'Pradėti nemokamai',
  },
  product: {
    heading: 'Profesionalūs pavežėjai\nnaudoja Finhudas',
    body: 'Automatiškai importuojame Bolt ataskaitas, skaičiuojame mokesčius ir generuojame apskaitos žurnalą.',
    button: 'Registruotis nemokamai',
  },
}

const FinhudasCTA = ({ variant = 'default', awareness = 'product' }: FinhudasCTAProps) => {
  const copy = ctaCopy[awareness]

  if (variant === 'compact') {
    return (
      <MotionDiv className="p-4 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl mb-6">
        <Link to="/users/register" className="flex items-center justify-between gap-3">
          <div>
            <MotionText as="p" className="text-white text-sm font-semibold">
              {copy.button}
            </MotionText>
            <MotionText as="p" className="text-blue-100 text-xs">
              Automatinė apskaita pavežėjams
            </MotionText>
          </div>
          <PiRocketLaunch className="w-6 h-6 text-white" />
        </Link>
      </MotionDiv>
    )
  }

  return (
    <MotionDiv className="p-5 bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-700 rounded-xl mb-6">
      <div className="flex gap-4">
        <div className="flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
          <PiRocketLaunch className="w-6 h-6 text-white" />
        </div>
        <div className="flex-1">
          <MotionText as="h3" className="text-white text-base font-semibold mb-2 whitespace-pre-line">
            {copy.heading}
          </MotionText>
          <MotionText as="p" className="text-blue-100 text-sm mb-2">
            {copy.body}
          </MotionText>
          <div className="flex items-center gap-1.5 mb-3">
            <PiUsers className="w-3.5 h-3.5 text-blue-200" />
            <span className="text-blue-200 text-xs">300+ pavežėjų jau naudoja</span>
          </div>
          <Link
            to="/users/register"
            className="inline-flex items-center gap-2 px-4 py-2 bg-white text-blue-700 text-sm font-semibold rounded-lg hover:bg-blue-50 transition-colors"
          >
            {copy.button}
          </Link>
        </div>
      </div>
    </MotionDiv>
  )
}

export default FinhudasCTA
